import './lesson-content.css';

import { DsIcon } from '@descomplica/design-system-react';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import { useEffect, useState } from 'react';
import React from 'react';

import { ClassroomViewModel, Lesson, Video } from '@/presentation/screens/classroom/classroom.vm';
import { ButtonContainer } from '@/presentation/shared-components/button';
import { VideoDescription } from '@/presentation/shared-components/text';

type LessonContentParam = {
  lesson: Lesson;
  video: Video;
};

const LessonContentContainer: React.FC<LessonContentParam> = ({
  lesson,
  video,
}: LessonContentParam) => {
  const vm = useViewModel(ClassroomViewModel);

  const [isCurrentVideo, setIsCurrentVideo] = useState(false);

  useEffect(() => {
    setIsCurrentVideo(video.guid === vm.currentVideo?.guid);
  }, [vm.currentVideo]);

  const onLessonVideoClick = () => {
    vm.setCurrentVideo(video);
    vm.setCurrentLesson(lesson);
    vm.handleLessonPlayed();
    vm.closeMobileSidebar();
    vm.getAutoPlayLesson();
    vm.setHasExerciseOpen(false);
  };

  return (
    <>
      <ButtonContainer
        className={isCurrentVideo ? 'current-lesson-content' : 'lesson-content'}
        onClick={onLessonVideoClick}
        ariaLabel={video.title}
      >
        <div className="preview-placeholder">
          <div
            className="video-preview-placeholder"
            style={{ backgroundImage: `url(${video.thumbUrl})` } as any}
            aria-hidden="true"
          />
        </div>
        <div className="preview-description">
          <VideoDescription className="video-description">{video.title}</VideoDescription>
          <div className="video-complete-icon">{video.isCompleted && <DsIcon image="check" />}</div>
        </div>
      </ButtonContainer>
    </>
  );
};

export default observer(LessonContentContainer);
